import { returnPolicyIdFormat } from "@redotech/redo-return-id";
import * as z from "zod";

/** Names one version of a policy; null or a blank name clears it. */
export const renameReturnPolicyVersion = {
  name: "renameReturnPolicyVersion" as const,
  input: z.object({
    id: returnPolicyIdFormat.schema,
    versionNumber: z.number().int(),
    name: z.string().max(200).nullable(),
  }),
  output: z.object({}),
};
